import { render, staticRenderFns } from "./UrmetOnboarding.vue?vue&type=template&id=28f52afc&"
import script from "./UrmetOnboarding.vue?vue&type=script&lang=ts&"
export * from "./UrmetOnboarding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports